"use client";

import { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";

/**
 * Sticky header that hides on scroll down and shows on scroll up
 */
export default function StickyBlogHeader({ children }) {
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Show header when scrolling up, hide when scrolling down
      if (currentScrollY < lastScrollY.current) {
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY.current && currentScrollY > 200) {
        setIsVisible(false);
      }
      
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box
      sx={{
        position: "fixed",
        top: { xs: "56px", md: "64px" },
        left: 0,
        right: 0,
        backgroundColor: "background.default",
        zIndex: 100,
        paddingTop: "0.5rem",
        paddingLeft: { xs: "1rem", sm: "2rem", md: "10rem", lg: "18rem" },
        paddingRight: { xs: "1rem", sm: "2rem", md: "10rem", lg: "18rem" },
        transform: isVisible ? "translateY(0)" : "translateY(-100%)",
        transition: "transform 0.4s ease-in-out",
      }}
    >
      {children}
    </Box>
  );
}
